import React, { useEffect, useState } from 'react';
import { FileText, CheckCircle, Clock, AlertTriangle, Building2, ChevronRight, BookText, ScrollText, Files, Settings, BarChart3, Mail, RefreshCw } from 'lucide-react';  // [PATCH edavki-ploscica v1] // [PATCH opal-k8 v1] RefreshCw
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { useNavigate } from 'react-router-dom';
import { IzbiraPodjetja } from '../components/IzbiraPodjetja'; // [PATCH aplikacije-fe v1] izluscen blok izbire podjetja
import { ciljAplikacije, preberiAplikacijo } from '../aplikacije'; // [PATCH aplikacije-fe v1]

const colorMap: Record<string, string> = {
  blue: 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400',
  green: 'bg-green-50 dark:bg-green-950 text-green-600 dark:text-green-400',
  amber: 'bg-amber-50 dark:bg-amber-950 text-amber-600 dark:text-amber-400',
  red: 'bg-red-50 dark:bg-red-950 text-red-600 dark:text-red-400',
  slate: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300',
};

// Polno obarvane menijske kartice (cel kvadratek), da se ločijo od bele statistične vrste
const menuStyle: Record<string, { card: string; chip: string; chev: string }> = {
  violet: {
    card: 'bg-violet-50 dark:bg-violet-500/15 border-violet-200 dark:border-violet-500/30 hover:border-violet-400 dark:hover:border-violet-500/60',
    chip: 'bg-violet-100 dark:bg-violet-500/25 text-violet-600 dark:text-violet-300',
    chev: 'text-violet-400 group-hover:text-violet-600 dark:group-hover:text-violet-300',
  },
  amber: {
    card: 'bg-amber-50 dark:bg-amber-500/15 border-amber-200 dark:border-amber-500/30 hover:border-amber-400 dark:hover:border-amber-500/60',
    chip: 'bg-amber-100 dark:bg-amber-500/25 text-amber-600 dark:text-amber-300',
    chev: 'text-amber-400 group-hover:text-amber-600 dark:group-hover:text-amber-300',
  },
  teal: {
    card: 'bg-teal-50 dark:bg-teal-500/15 border-teal-200 dark:border-teal-500/30 hover:border-teal-400 dark:hover:border-teal-500/60',
    chip: 'bg-teal-100 dark:bg-teal-500/25 text-teal-600 dark:text-teal-300',
    chev: 'text-teal-400 group-hover:text-teal-600 dark:group-hover:text-teal-300',
  },
  cyan: {  // [PATCH mail-vhod-D2 v1]
    card: 'bg-cyan-50 dark:bg-cyan-500/15 border-cyan-200 dark:border-cyan-500/30 hover:border-cyan-400 dark:hover:border-cyan-500/60',
    chip: 'bg-cyan-100 dark:bg-cyan-500/25 text-cyan-600 dark:text-cyan-300',
    chev: 'text-cyan-400 group-hover:text-cyan-600 dark:group-hover:text-cyan-300',
  },
  rose: {
    card: 'bg-rose-50 dark:bg-rose-500/15 border-rose-200 dark:border-rose-500/30 hover:border-rose-400 dark:hover:border-rose-500/60',
    chip: 'bg-rose-100 dark:bg-rose-500/25 text-rose-600 dark:text-rose-300',
    chev: 'text-rose-400 group-hover:text-rose-600 dark:group-hover:text-rose-300',
  },
  sky: {
    card: 'bg-sky-50 dark:bg-sky-500/15 border-sky-200 dark:border-sky-500/30 hover:border-sky-400 dark:hover:border-sky-500/60',
    chip: 'bg-sky-100 dark:bg-sky-500/25 text-sky-600 dark:text-sky-300',
    chev: 'text-sky-400 group-hover:text-sky-600 dark:group-hover:text-sky-300',
  },
  // [PATCH opal-k8 v1] ploscica Sinhronizacija (cakalnica Opal sync)
  indigo: {
    card: 'bg-indigo-50 dark:bg-indigo-500/15 border-indigo-200 dark:border-indigo-500/30 hover:border-indigo-400 dark:hover:border-indigo-500/60',
    chip: 'bg-indigo-100 dark:bg-indigo-500/25 text-indigo-600 dark:text-indigo-300',
    chev: 'text-indigo-400 group-hover:text-indigo-600 dark:group-hover:text-indigo-300',
  },
  // [PATCH edavki-ploscica v1]
  emerald: {
    card: 'bg-emerald-50 dark:bg-emerald-500/15 border-emerald-200 dark:border-emerald-500/30 hover:border-emerald-400 dark:hover:border-emerald-500/60',
    chip: 'bg-emerald-100 dark:bg-emerald-500/25 text-emerald-600 dark:text-emerald-300',
    chev: 'text-emerald-400 group-hover:text-emerald-600 dark:group-hover:text-emerald-300',
  },
};

export function DashboardPage() {
  const { selectedCompany, setSelectedCompany } = useAuthStore();
  const [smeOdpirati, setSmeOdpirati] = useState(false); // [PATCH odpiranje-baz-fe v1]

  // [PATCH odpiranje-baz-fe v1] pravica do odpiranja nove baze
  // (superadmin ALI can_create_companies) -- vzorec iz DashboardLayout
  useEffect(() => {
    api.get('/auth/me')
      .then((r: any) => setSmeOdpirati(
        !!(r.data.is_superadmin || r.data.can_create_companies)))
      .catch(() => setSmeOdpirati(false));
  }, []);
  const [companies, setCompanies] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [dbStats, setDbStats] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedCompany) {
      api.get('/companies/' + selectedCompany.id + '/stats').then(r => setDbStats(r.data)).catch(() => {});
    }
  }, [selectedCompany]);

  // [PATCH sinhronizacija-program-ime v1] program izvoza podjetja (opis ploščice Sinhronizacija)
  const [izvozProgram, setIzvozProgram] = useState<string | null>(null);
  useEffect(() => {
    setIzvozProgram(null);
    if (selectedCompany) {
      api.get('/profil/' + selectedCompany.id).then(r => setIzvozProgram(r.data?.izvoz_program ?? null)).catch(() => {});
    }
  }, [selectedCompany]);

  useEffect(() => {
    api.get('/companies/')
      .then(r => setCompanies(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const izberi = (company: any) => {
    setSelectedCompany(company);
    navigate(ciljAplikacije(preberiAplikacijo())); // [PATCH aplikacije-fe v1] cilj po aplikaciji (brez konteksta: /dokumenti kot prej)
  };

  // Če stranka ni izbrana — pokaži izbiro
  if (!selectedCompany) {
    return <IzbiraPodjetja companies={companies} loading={loading} smeOdpirati={smeOdpirati} onIzberi={izberi} />; /* [PATCH aplikacije-fe v1] JSX izluscen 1:1 v components/IzbiraPodjetja.tsx */
  }

  // Stranka je izbrana — pokaži dashboard
  const stats = [
    { label: 'Dokumenti danes', value: dbStats?.danes ?? 0, icon: FileText, color: 'blue' },
    { label: 'Potrjeni', value: dbStats?.po_statusu?.approved ?? 0, icon: CheckCircle, color: 'green' },
    { label: 'Čakajo pregled', value: (dbStats?.po_statusu?.review_needed ?? 0) + (dbStats?.po_statusu?.validated ?? 0), icon: Clock, color: 'amber' },
    { label: 'Skupaj dokumentov', value: dbStats?.skupaj ?? 0, icon: Files, color: 'slate' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{selectedCompany.name}</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-1">Nadzorna plošča</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map(({ label, value, icon: Icon, color }) => (
          <div key={label} className="bg-white dark:bg-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-800">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${colorMap[color]}`}>
                <Icon className="w-5 h-5" />
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900 dark:text-white">{value}</div>
            <div className="text-sm text-gray-500 dark:text-gray-400 mt-1">{label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: 'Profil podjetja', desc: 'Podatki podjetja', path: '/profil', icon: Building2, color: 'violet' },
          { label: 'Šifranti', desc: 'Partnerji in konti', path: '/sifranti', icon: BookText, color: 'amber' },
          { label: 'Dnevnik', desc: 'Dnevnik dogodkov', path: '/dnevnik', icon: ScrollText, color: 'teal' },
          { label: 'Insolventnost', desc: 'Spremljanje insolventnosti', path: '/insolventnost', icon: AlertTriangle, color: 'rose' },
          { label: 'ePošta', desc: 'Prejeti računi po e-pošti', path: '/eposta', icon: Mail, color: 'cyan' },  // [PATCH mail-vhod-D2 v1]
          { label: 'Statistika', desc: 'Oddani obrazci na eDavkih', path: '/edavki', icon: BarChart3, color: 'emerald' },  // [PATCH edavki-ploscica v1]
          { label: 'Nastavitve', desc: 'bizBox in ostalo', path: '/nastavitve', icon: Settings, color: 'sky' },
          { label: 'Sinhronizacija', desc: izvozProgram === 'vasco' ? 'Čakalnica razhajanj z Vascom' : 'Čakalnica razhajanj z Opalom', path: '/sinhronizacija', icon: RefreshCw, color: 'indigo' },  // [PATCH opal-k8 v1] // [PATCH sinhronizacija-program-ime v1]
        ].map(({ label, desc, path, icon: Icon, color }) => (
          <button key={path} onClick={() => navigate(path)}
            className={`text-left rounded-2xl border p-5 hover:shadow-md transition group ${menuStyle[color].card}`}>
            <div className="flex items-center justify-between">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${menuStyle[color].chip}`}>
                <Icon className="w-5 h-5" />
              </div>
              <ChevronRight className={`w-5 h-5 transition ${menuStyle[color].chev}`} />
            </div>
            <p className="font-semibold text-gray-900 dark:text-white mt-3">{label}</p>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
